// ------------------------------------
// props 輸入需求 :
// props.isON : boolean    ( 元件開關 )
// props.type : str        ( 'bed', 'name' )
// props.data : str        ( 根據 type 放名或床 )
// ------------------------------------


import React from 'react'
import { useTranslation } from 'react-i18next';
import Account from '../../../../actions/Account';
import { DF } from '../../../dashboard/DashFunction';
const BEDandName =(props)=>{
    const { t } = useTranslation(); // 1.2 i18n
    if(Account.isMobileOrTablet()){
        return(
            <div className={`${Account.isMobile()?"littleUi":""} fx-ccc`}>
                {props.isON?
                    <div className="top-tag fx-d-c mar-r">
                        <div className="name m fx-ccc">{(props.type==='bed')? t("GLOBAL.BED_NO"): t("GLOBAL.NAME")}</div>
                        <div className="fx-ccc def"><div className="inner">{DF.abbreviate(props.data, 5)}</div></div>
                    </div>
                :null}
            </div>
        );
    }
    else{
        return(
            <div className="fx-ccc w-100">
                {props.isON?
                    <div className="top-tag fx-d-r mar-r" style={{ minWidth: 0 }}>
                        <div className="name fx-ccc">{(props.type==='bed')? t("GLOBAL.BED_NO"): t("GLOBAL.NAME")}</div>
                        <div className="body def" style={{ minWidth: 0, overflow: "hidden" }}>
                            <div
                                className="inner"
                                title={props.data}
                                style={{ display: "block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", maxWidth: "8em" }}
                            >
                                {DF.abbreviate(props.data, 'all')}
                            </div>
                        </div>
                    </div>
                :null}
            </div>
        );
    }
}
export default BEDandName;